export interface IntegrationTestSuite {
  id: string
  description: string
}

export interface IntegrationTestCase {
  id: string
  description: string
}

export enum LocalIntegrationTestCaseExecutionType {
  NOT_EXECUTED = 'not_executed',
  FAILED = 'failed',
  PASSED = 'passed',
}

export interface LocalIntegrationTestCase extends IntegrationTestCase {
  execution: {
    status: LocalIntegrationTestCaseExecutionType
  }
}

export interface IntegrationTestCaseDetail {
  id?: string
  suite_id?: string
  description?: string
  input_gateway?: string
  input_route?: string
  input_definition?: object
  expectation_definition?: object
}
